module.exports = __webpack_public_path__ + "static/img/mr.d8751050.svg";